import React from "react";

import { ExecutorGroupCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function executorGroup({ width, onResize }: Column.Options) {
	return base(ColumnId.ExecutorGroup, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default executorGroup;
